import { CompanyGlobalFinancialMonitoringPartOne } from '../components';
import { useCompanyGlobalFinancialMonitoringPartOne } from '../hooks/useCompanyGlobalFinancialMonitoringPartOne';
import { PageComponentProps } from '../types';

export const CompanyGlobalFinancialMonitoringPartOneStep = ({
  canGoBack,
}: PageComponentProps) => {
  const { initialValues, onSubmit, submitLoading, goToBack } =
    useCompanyGlobalFinancialMonitoringPartOne();

  return (
    <CompanyGlobalFinancialMonitoringPartOne
      canGoBack={canGoBack}
      initialValues={initialValues}
      submitLoading={submitLoading}
      onGoBack={goToBack}
      onSubmit={onSubmit}
    />
  );
};
